// on search pages, adjust height to fit on screen
function adjustSiteSearchHeight() {
    const siteSearchHeader = document.querySelector('.site-search');
    const footer = document.querySelector('.footer');

    if (!siteSearchHeader || !footer) return; // Ensure both elements exist

    function updateHeight() {
        const footerHeight = footer.offsetHeight;
        siteSearchHeader.style.minHeight = `calc(100dvh - ${footerHeight}px)`;
    }

    updateHeight(); // Set initial height
    
    window.addEventListener('resize', updateHeight); // Update on resize
}

document.addEventListener('DOMContentLoaded', adjustSiteSearchHeight);

// add autofocus attribute on page load
document.addEventListener("DOMContentLoaded", function () {
    const interval = setInterval(function () {
        const searchInput = document.getElementById("autocomplete-0-input");
        if (searchInput) {
            searchInput.focus();  // Focus the input element
            clearInterval(interval);  // Stop checking once the input is focused
        }
    }, 100);  // Check every 100ms for the input element
});
